var render = function render(){var _vm=this,_c=_vm._self._c;return _c('TemplateTable',{attrs:{"title":_vm.$t('menu.data'),"name":"monitoringDatas","url":_vm.$listRoutes.monitoringDatas,"table":_vm.monitoringDatas,"filters":_vm.monitoringDatasFilters,"fields":_vm.fields}})
}
var staticRenderFns = []

export { render, staticRenderFns }